import { render, staticRenderFns } from "./trace.vue?vue&type=template&id=639ee1f0&scoped=true&"
import script from "./trace.vue?vue&type=script&lang=js&"
export * from "./trace.vue?vue&type=script&lang=js&"
import style0 from "./trace.vue?vue&type=style&index=0&id=639ee1f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639ee1f0",
  null
  
)

export default component.exports